import {CODPaymentInformation} from '../hooks/useCodPaymentInformation';

export function isBankDataEntered(
  codPaymentInformation?: CODPaymentInformation | null,
): codPaymentInformation is CODPaymentInformation {
  return Boolean(
    codPaymentInformation?.bankData?.firstName &&
      codPaymentInformation?.bankData?.lastName &&
      codPaymentInformation?.bankData?.iban,
  );
}
